import {useEffect, useState} from 'react';

interface UseChatResizeOptions {
    panelWidth: number;
    setPanelWidth: (width: number) => void;
    minWidth?: number;
    maxWidth?: number;
}

export function useChatResize({
    panelWidth: _panelWidth,
    setPanelWidth,
    minWidth = 320,
    maxWidth = 800,
}: UseChatResizeOptions) {
    const [isResizing, setIsResizing] = useState(false);

    useEffect(() => {
        const handleMouseMove = (e: MouseEvent) => {
            if (!isResizing) return;

            const newWidth = window.innerWidth - e.clientX;
            const clampedWidth = Math.max(
                minWidth,
                Math.min(maxWidth, newWidth)
            );
            setPanelWidth(clampedWidth);
        };

        const handleMouseUp = () => {
            setIsResizing(false);
            document.body.style.cursor = '';
            document.body.style.userSelect = '';
        };

        if (isResizing) {
            document.body.style.cursor = 'ew-resize';
            document.body.style.userSelect = 'none';
            document.addEventListener('mousemove', handleMouseMove);
            document.addEventListener('mouseup', handleMouseUp);
        }

        return () => {
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
        };
    }, [isResizing, minWidth, maxWidth, setPanelWidth]);

    const startResizing = () => {
        setIsResizing(true);
    };

    return {
        isResizing,
        startResizing,
    };
}
